import React from "react";
import PageContent from "../../../common/components/atom/PageContent/PageContent";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SingleWallet from "../../../features/wallet/components/wallets/SingleWallets";
import ButtonSmallIcon from "../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import styles from "./SingleWalletPage.module.scss";
import SingleTransactionPage, {
  SingleTransactionDrawer,
} from "../../TransactionPages/SingleTransactionPage/SingleTransactionPage";
import {
  AddCreditDrawer,
} from "../../TransactionPages/AddCreditPage/AddCreditPage";

import SingleClient from "../../../features/clients/components/SingleClient";
import useNavigationApp from "../../../navigation/useNavigationApp";

import { CreatePayGoPageDrawer } from "../CreatePayGoPage/CreatePayGoPage";
import { useSingleWallet } from "../../../features/wallet/hooks/useWallet";
import { JWayIcon } from "../../../common/assets/JWayIcons";

export default function SingleWalletPage() {
  const navigtion = useNavigationApp();
  const {
    singleWalletQuery: { data: walletData },
  } = useSingleWallet();
  return (
    <>
      <PageContent>
        <HeaderTitleContent withGoBackBtn>
          {" "}
          <SingleWallet.Info info="wallet_name" />{" "}
        </HeaderTitleContent>
        <div className={[styles["header-info"]].join(" ")}>
          {walletData?.wallet_type !== "ORGANIZATION" && (
            <>
              <SingleWallet.Info
                info="wallet_user_orga_id"
                renderComponent={({ value }) => (
                  <ButtonSmallIcon
                    iconType="profil"
                    onClick={() => {
                      navigtion.goToSingleClientExtend(value as string);
                    }}
                    valueRender={() => (
                      <>
                        <SingleClient.InfoExtend
                          info="client_firstname"
                          userOrgaId={value as string}
                        />{" "}
                        <SingleClient.InfoExtend
                          info="client_lastname"
                          userOrgaId={value as string}
                        />
                      </>
                    )}
                  />
                )}
              />
            </>
          )}
        </div>
        <div className={[styles["header-general"]].join(" ")}>
          <div
            className={[
              styles["header-general__amount-container"],
              styles["amount-container"],
            ].join(" ")}
          >
            <p className={[styles["amount-container__subtitle"]].join(" ")}>
              CRÉDIT DISPONIBLE
            </p>
            <h2
              className={[
                styles["amount-container__title-amount"],
                styles["title-amount"],
              ].join(" ")}
            >
              <SingleWallet.Info info="wallet_amount" />{" "}
              <span
                className={[
                  styles["amount-container__title-amount__unit"],
                ].join(" ")}
              >
                <SingleWallet.Info info="wallet_currency" />
              </span>
            </h2>
            { walletData?.wallet_pending_amount !== walletData?.wallet_amount &&
            <h2
              className={[
                styles["amount-container__title-amount-pending"],
                styles["title-amount-pending"],
              ].join(" ")}
            >
              <span style={{marginRight: 10}}><JWayIcon type="time" color="#6A6A6A" size={15}/></span>
              <SingleWallet.Info info="wallet_pending_amount" />{" "}
              <span
                className={[
                  styles["title-amount-pending__unit"],
                ].join(" ")}
              >
                <SingleWallet.Info info="wallet_currency" />
              </span>
            </h2>
}
          </div>
          <div
            className={[
              styles["header-general__btn-action-container"],
              styles["btn-action-container"],
            ].join(" ")}
          >
            {walletData?.wallet_type !== "ORGANIZATION" && (
              <SingleWallet.WalletActionBtn />
            )}
          </div>
          <div></div>
        </div>
        <div style={{ height: "50px" }} />

        <SectionTitle iconType="exchange">Transactions</SectionTitle>
        <SingleWallet.TransactionList />
      </PageContent>
      <SingleTransactionDrawer>
        <SingleTransactionPage />
      </SingleTransactionDrawer>

      <AddCreditDrawer/>
       
     
      <CreatePayGoPageDrawer />
    </>
  );
}
